import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { BLOG_POSTS_FULL } from "../../data/blogPosts";

export default function BlogSection() {
  const posts = BLOG_POSTS_FULL.slice(0, 3);
  return (
    <section
      id="blog"
      className="py-20 md:py-28 bg-white"
      data-testid="blog-section"
    >
      <div className="container">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-8">
            <p className="text-overline text-electric mb-3">09 — Resources</p>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold text-charcoal text-balance">
              Field notes from the App Store Optimization frontline.
            </h2>
          </div>
          <Link
            to="/blog"
            data-testid="all-blog-link"
            className="lg:col-span-4 lg:justify-self-end inline-flex items-center gap-2 text-charcoal font-semibold hover:text-electric"
          >
            All posts <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {posts.map((p, idx) => (
            <motion.article
              key={p.slug}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.06 }}
              className="group"
              data-testid={`home-blog-card-${idx}`}
            >
              <Link
                to={`/blog/${p.slug}`}
                className="border border-zinc-200 bg-white hover:border-charcoal transition-colors flex flex-col h-full"
              >
                <div className="aspect-[16/10] overflow-hidden bg-zinc-100 border-b border-zinc-200">
                  <img
                    src={p.cover}
                    alt={`${p.title} — Lumotis digital marketing blog cover`}
                    className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-500"
                    width="600"
                    height="375"
                    loading="lazy"
                  />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <span className="text-overline text-electric mb-3">
                    {p.category}
                  </span>
                  <h3 className="font-display text-xl font-bold text-charcoal leading-snug">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-[15px] text-zinc-600 leading-relaxed flex-1">
                    {p.excerpt}
                  </p>
                  <div className="mt-6 pt-5 border-t border-zinc-200 flex items-center justify-between text-xs text-zinc-500">
                    <span className="inline-flex items-center gap-1.5">
                      <Clock className="w-3.5 h-3.5" /> {p.readTime}
                    </span>
                    <span className="inline-flex items-center gap-1 text-charcoal font-semibold group-hover:text-electric">
                      Read <ArrowUpRight className="w-3.5 h-3.5" />
                    </span>
                  </div>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
